// Map internal IDs to URL slugs for each language
export const routeConfig = {
    // Core routes
    home: {
        tr: '/',
        nl: '/nl'
    },
    // The 5 selected calculators for NL
    percentage: {
        tr: 'https://yuzde.hesaplama.vip/',
        nl: '/nl/percentage-berekenen'
    },
    pronunciation: {
        tr: 'https://sayiokunusu.hesaplama.vip/',
        nl: '/nl/getal-schrijven'
    },
    goldCalculator: {
        tr: 'https://altin.hesaplama.vip/',
        nl: '/nl/goud-berekenen'
    },
    sqrt: {
        tr: 'https://karekok.hesaplama.vip/',
        nl: 'https://karekok.hesaplama.vip/nl/wortel-berekenen'
    },
    // Currency converters (Grouped under 'currency' concept but individual pages in TR)

    dollarEuro: {
        tr: '/dolar-euro-cevirici',
        nl: '/nl/dollar-naar-euro'
    },
    about: {
        tr: '/hakkinda',
        nl: '/hakkinda' // Already points to Turkish URL
    },
    contact: {
        tr: '/iletisim',
        nl: '/iletisim' // Already points to Turkish URL
    },
    privacyPolicy: {
        tr: '/gizlilik-politikasi',
        nl: '/gizlilik-politikasi' // Already points to Turkish URL
    }
};

// Helper to get ID from path
export const getIdFromPath = (path: string): string | null => {
    // Normalize path (remove trailing slash)
    const normalizedPath = path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;

    for (const [id, slugs] of Object.entries(routeConfig)) {
        if (Object.values(slugs).includes(normalizedPath)) {
            return id;
        }
    }

    // Handle sub-paths (SEO pages)
    // e.g. /nl/percentage-berekenen/100-van-200
    // Skip 'home' for startsWith check to avoid it catching everything starting with /nl/
    for (const [id, slugs] of Object.entries(routeConfig)) {
        if (id === 'home') continue;
        if (slugs.nl && normalizedPath.startsWith(slugs.nl + '/')) return id;
        if (slugs.tr && normalizedPath !== '/' && normalizedPath.startsWith(slugs.tr + '/')) return id;
    }

    return null;
};

// Helper to get URL for ID and Language
export const getUrlForId = (id: string, lang: 'tr' | 'nl'): string | null => {
    const config = routeConfig[id as keyof typeof routeConfig];
    if (!config) return null;

    return (config as any)[lang] || null;
};
